import { PDFDownloadLink, Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import RequiredInfo from 'Components/Client/Cases/CaseDetails/RequiredInfo';
import { basicCaseInfo, caseTypeCommonFields } from 'Components/Client/Cases/CaseFormFields';
import DownloadIcon from 'Components/Icons/DownloadIcon';
import { getCaseType } from 'Utils';

export const MyDoc = ({caseDetails}) => {
  const styles = StyleSheet.create({
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
      fontSize: 12
    },
    title: {
      fontSize: 20,
      textAlign: 'left',
      marginTop: 20
    },
    container: {
      display: "flex",
      marginTop: 10,
      marginBottom: 10,
      flexDirection: "row"
    },
    containerAdd : {
      display: "flex",
      marginTop: 10,
      marginBottom: 10,
    },
    label: {
      width: "100%",
      color: 'grey'
    },
    value:{
      width: "100%"
    }
  });
  
  const additionalFields = (caseDetails && caseDetails.additionalFields && Object.entries(caseDetails?.additionalFields).length 
  ?
  JSON.parse(caseDetails?.additionalFields)
  :
  "")
  ;

  const basicDetails = basicCaseInfo[0]?.map((item) => 
  {
    if(caseDetails?.[item.name]) 
    {
      return ( 
      <View style={styles.container}> 
        <Text  style={styles.label}>{item.label}</Text>
        <Text style={styles.value}>{caseDetails?.[item.name]}</Text>
      </View>
    )
    }
  })
  const additionalInfo = (additionalFields ?
       caseTypeCommonFields.map((item) => (
      item.fields.map((i) => {

      if(additionalFields?.[i.name])
      {
              return (
                <View style={styles.containerAdd}> 
                  <Text style={styles.label}>{i.label} </Text>
                  <Text style={styles.value}>{additionalFields[i.name]}</Text>
              </View> 
              )
          
      }}
      )
       ))
      :
      <View style={styles.containerAdd}> 
        <Text style={styles.value}>No data</Text>
    </View> );

      
  return <Document>
    <Page  style={styles.body}>
      <View >
        <Text style={styles.title}>Basic Details of case {caseDetails?.caseNumber}</Text>
        {basicDetails}

        <Text style={styles.title}>Additional Details</Text>
        {additionalInfo}
        <Text style={styles.title}>Extra information on the issue : </Text>
        <View style={styles.container}> 
            <Text style={styles.value}>{caseDetails?.additionalNotes ? caseDetails?.additionalNotes : "No data"}</Text>
        </View>
      </View>
    </Page>
  </Document>
}

const MakeDownloadblePdf = ({caseDetails, content}) => (
  <div>
    <PDFDownloadLink document={<MyDoc caseDetails={caseDetails} />} fileName={getCaseType(caseDetails.caseType) + ".pdf"}>
      {({ blob, url, loading, error }) =>
        loading ? '...' : <>{content}</>
      }
    </PDFDownloadLink>
  </div>
);

export default MakeDownloadblePdf;